// extracted by mini-css-extract-plugin
export default {"watchlist-card-container":"sy4sdfVly5AhBP_4o7w6","watchlist-card":"cbxcn3HFi8yxnH9gMlaL","as-of-date-container":"cKvQHHAFTLb6TSu2_QX8"};